import { gql } from 'graphql-request';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';

export const useDeleteAssignment = () => {
  const { client } = graphqlConfig();
  const Mutation = useMutation(async (assignmentId?: number) => client.request(
    gql`
    mutation AdminDeleteAssignment($assignmentId: Float!) {
      adminDeleteAssignment(assignmentId: $assignmentId) {
        message
      }
    }
    `,
    {
      assignmentId: Number(assignmentId)
    }
  ).catch((error) => toast(error.response.errors[0].message)), {
    onSuccess: (data: any) => { toast(data?.deletePost?.message); }
  });
  return Mutation;
};
